'use client'

import { useEffect, useRef, useState } from 'react'

// Detect when a `position: sticky` element has crossed its scroll threshold
// and is "stuck" to the viewport edge. Inserts a 1px sentinel just above the
// target so a stock IntersectionObserver can flip a boolean without listening
// to scroll events.
export function useStuckPicker<T extends HTMLElement>() {
  const ref = useRef<T | null>(null)
  const [stuck, setStuck] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el || typeof IntersectionObserver === 'undefined') return

    const sentinel = document.createElement('div')
    sentinel.setAttribute('aria-hidden', 'true')
    sentinel.style.cssText =
      'position:absolute;top:-1px;left:0;right:0;height:1px;pointer-events:none;'
    el.parentNode?.insertBefore(sentinel, el)

    const observer = new IntersectionObserver(
      ([entry]) => setStuck(!entry.isIntersecting),
      { threshold: [0, 1] },
    )
    observer.observe(sentinel)
    return () => {
      observer.disconnect()
      sentinel.remove()
    }
  }, [])

  return { ref, stuck }
}
